import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "activity-sidebar" }
const _hoisted_2 = { class: "activity-sidebar__content-wrapper" }
const _hoisted_3 = { class: "activity-sidebar__header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, " My notifications ", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "flex flex--justify-center mb-12"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_SidebarNotificationsComponent = _resolveComponent("SidebarNotificationsComponent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["activity-sidebar__content", { 'activity-sidebar__content--loading': $data.loading }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_router_link, {
            class: "arrow-link",
            to: { name: 'notifications' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" See all ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createVNode(_component_SidebarNotificationsComponent, { notifications: $options.notifications }, null, 8 /* PROPS */, ["notifications"]),
        ($options.notifications.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                class: "arrow-link",
                to: { name: 'notifications' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" See all notifications ")
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ])
  ]))
}